var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTiktok = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.38 0h-3.316v13.621c0 1.621-1.284 2.958-2.874 2.958a2.915 2.915 0 0 1-2.863-2.947 2.948 2.948 0 0 1 2.779-2.969v-3.42a6.284 6.284 0 0 0-6.105 6.378A6.294 6.294 0 0 0 7.21 20a6.316 6.316 0 0 0 6.232-6.379V6.642a7.621 7.621 0 0 0 4.4 1.505v-3.42A4.663 4.663 0 0 1 13.38 0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTiktok);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tiktok.f7e9e8ea3d43d2174ab4089880eadd9c.svg";